var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 10C20 15.524 15.523 20 10 20C4.477 20 0 15.524 0 10C0 4.478 4.477 0 10 0C15.523 0 20 4.478 20 10Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99414 12.9287C10.4871 12.9287 10.8791 13.3217 10.8791 13.8037C10.8791 14.2857 10.4871 14.6787 10.0041 14.6787C9.51914 14.6787 9.12414 14.2857 9.12414 13.8037C9.12414 13.3217 9.51514 12.9287 9.99414 12.9287ZM9.99414 5.33594C10.4761 5.33594 10.8691 5.72894 10.8691 6.21094V10.6309C10.8691 11.1129 10.4761 11.5059 9.99414 11.5059C9.51214 11.5059 9.11914 11.1129 9.11914 10.6309V6.21094C9.11914 5.72894 9.51214 5.33594 9.99414 5.33594Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.2cee167b8d38435b400c5068e29b3caf.svg";
export { ForwardRef as ReactComponent };